import * as React from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { Globe } from "lucide-react";

export default function LocaleModal(props) {
  const { trigger, initialLanguage = defaultLanguage(), initialRegion = defaultRegion(), onApply } = props || {};

  const [open, setOpen] = React.useState(false);
  const [language, setLanguage] = React.useState(initialLanguage);
  const [region, setRegion] = React.useState(initialRegion);

  React.useEffect(() => {
    try {
      const savedLang = localStorage.getItem("ant_locale_lang");
      const savedReg = localStorage.getItem("ant_locale_region");
      if (savedLang) setLanguage(savedLang);
      if (savedReg) setRegion(savedReg);
    } catch (_) {
      // ignore if storage is blocked
    }
  }, []);

  function handleApply() {
    try {
      localStorage.setItem("ant_locale_lang", language);
      localStorage.setItem("ant_locale_region", region);
    } catch (_) {}
    if (onApply) onApply({ language, region });
    setOpen(false);
  }

  return (

    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger ?? (
          <Button variant="ghost" className="px-3">
            <span className="tracking-wide"> Language / Region</span>
          </Button>
        )}
      </DialogTrigger>

      <DialogContent className="items-center mx-auto sm:rounded-3xl rounded-3xl bg-white/60 border-2 border-white h-auto w-[calc(100%-16px)] p-6">
{/*       <DialogContent className="items-center rounded-none md:rounded-3xl bg-white/60 md:border-2 md:border-white h-full md:h-auto w-full p-6"> */}

    {/*   rounded-3xl
                inset-2
                bottom-2 right-2
                w-auto         
                md:w-[480px]       
                h-auto
                
                bg-[rgb(var(--card))]
                text-[rgb(var(--card-foreground))]
                flex flex-col */}
       
      <div className="max-w-prose items-center mx-auto"> 
        <DialogHeader className="p-6">
         <DialogTitle className="font-kalice font-medium text-3xl mb-2 flex items-center text-left"><Globe className=" w-6 h-6 mr-2 shrink-0"/>Language</DialogTitle>
          <DialogDescription className="font-sans text-sm text-black/60 w-full text-left">
            Choose your preferred language and shipping region below. If your region is not yet listed, please select <span className="font-bold">international</span> for worldwide shipping.
          </DialogDescription>

        </DialogHeader>

        <div className="grid gap-6 py-8 bg-white p-6 rounded-2xl">
          <div className="grid gap-2 font-sans text-sm font-medium">
            <Label htmlFor="language">Language</Label>
            <Select value={language} onValueChange={setLanguage}>
              <SelectTrigger id="language" className="h-11 text-black border-black bg-white">
                <SelectValue placeholder="Select language" />
              </SelectTrigger>
              <SelectContent className="rounded-xl">
                {languages.map((l) => (
                  <SelectItem key={l.code} value={l.code}>
                    {l.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="grid gap-2 font-sans text-sm font-medium">
            <Label htmlFor="region">Region</Label>
            <Select value={region} onValueChange={setRegion}>
              <SelectTrigger id="region" className="h-11 text-black border-black bg-white">
                <SelectValue placeholder="Select region" />
              </SelectTrigger>
              <SelectContent className="rounded-xl max-h-72">
                {regions.map((r) => (
                  <SelectItem key={r.code} value={r.code}>
                    {r.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button className="rounded-none w-full" onClick={handleApply}>Apply</Button>
        </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

// --- Config --- //
export const languages = [
  { code: "en", label: "English" },
  { code: "nl", label: "Nederlands" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "es", label: "Español" },
];

export const regions = [
  { code: "en-gb", label: "United Kingdom / International" },
  { code: "nl-nl", label: "Netherlands" },
  { code: "fr-fr", label: "France" },
  { code: "de-de", label: "Germany" },
  { code: "it-it", label: "Italy" },
  { code: "es-es", label: "Spain" },
  { code: "ch-de", label: "Switzerland (DE)" },
  { code: "be-nl", label: "Belgium (NL)" },
  { code: "be-fr", label: "Belgium (FR)" },
];

function defaultLanguage() {
  if (typeof navigator === "undefined") return "en";
  const lang = (navigator.language || "en").split("-")[0];
  return languages.some((l) => l.code === lang) ? lang : "en";
}

function defaultRegion() {
  // keep it simple: default to UK/International
  return "en-gb";
}
